import React from 'react'
import { Row } from '@fs/zion-ui'

// This wraps our use of Row in the sidesheet BUT also the bottom sheet. Because the specs are so finickey, we put them all here, in one place.
const RowWrapper = ({ children, alignY = 'bottom' }) => {
  return (
    <Row gutters="sm" guttersY="none" wrap alignX="start" alignY={alignY}>
      {children}
    </Row>
  )
}

export default RowWrapper
